var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTalkActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 235,
    viewBox: "0 0 180 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.558 0H7.16989C3.19227 0 0 3.12011 0 6.95269V114.732C0 118.589 3.21761 121.684 7.16989 121.684H43.0698L38.8641 156.964C38.5348 159.814 40.0042 162.565 42.6137 163.916C43.6778 164.457 44.8432 164.727 45.9833 164.727C47.6554 164.727 49.3023 164.162 50.645 163.056L100.758 121.66H172.532C176.51 121.66 179.702 118.54 179.702 114.707V6.95269C179.702 3.09554 176.485 0 172.532 0H172.558ZM165.388 107.779H98.1484C96.451 107.779 94.7788 108.369 93.4867 109.45L55.2307 141.044L58.2708 115.567C58.4989 113.602 57.8655 111.612 56.4974 110.137C55.1293 108.663 53.1785 107.803 51.1264 107.803H14.3397V13.9299H165.362V107.779H165.388Z",
    fill: "url(#paint0_linear_238_1643)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1331 49.9171H137.57C141.559 49.9171 144.76 46.5569 144.76 42.4295C144.76 38.302 141.534 34.9419 137.57 34.9419H42.1331C38.1439 34.9419 34.9424 38.302 34.9424 42.4295C34.9424 46.5569 38.1693 49.9171 42.1331 49.9171Z",
    fill: "url(#paint1_linear_238_1643)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1331 89.8507H137.57C141.559 89.8507 144.76 86.4905 144.76 82.3631C144.76 78.2356 141.534 74.8755 137.57 74.8755H42.1331C38.1439 74.8755 34.9424 78.2356 34.9424 82.3631C34.9424 86.4905 38.1693 89.8507 42.1331 89.8507Z",
    fill: "url(#paint2_linear_238_1643)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0805 221.719V195.527H11.152V188.923H38.871V195.527H28.9425V221.719H21.0805ZM43.2302 221.719L53.9674 188.923H64.3003L74.9926 221.719H66.5915L59.1788 195.437H59.0889L51.6313 221.719H43.2302ZM50.2386 214.935V208.511H67.9842V214.935H50.2386ZM85.1303 221.719V188.923H92.9923V215.115H109.255V221.719H85.1303ZM120.342 221.719V188.923H127.98V203.12H128.07L139.66 188.923H148.646L135.797 204.782L149.095 221.719H140.11L128.07 206.444H127.98V221.719H120.342Z",
    fill: "#75BDFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_238_1643",
    x1: 0,
    y1: 82.3635,
    x2: 179.702,
    y2: 82.3635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF48E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_238_1643",
    x1: 34.9424,
    y1: 42.4295,
    x2: 144.76,
    y2: 42.4295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF48E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_238_1643",
    x1: 34.9424,
    y1: 82.3631,
    x2: 144.76,
    y2: 82.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF48E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkActive);
export default __webpack_public_path__ + "static/media/talk_active.78f92a6ada1d8e85ffe50e95d3ab891a.svg";
export { ForwardRef as ReactComponent };